import { TypographyProps, TypographyColorToken } from '@bcp-nextgen-dx-component-factory/design-system';

export type DisplayCostAppearance = 'promotionalMain' | 'main' | 'secondary' | 'promotionalSecondary' | 'tertiary';

interface AppearanceGroups {
	costAppearance: TypographyProps;
	currencyAppearance: TypographyProps;
	frequencyAppearance: TypographyProps;
}

type TextAppearances = {
	[key in DisplayCostAppearance]: AppearanceGroups;
};

const headlineToken = 'headline-500-01';
const body100Token = 'body-100-06';
const body75Token = 'body-100-02';
const headlineSecondaryToken = 'headline-75-01';
const subtitle100Token = 'subtitle-100-06';
const colorTokenPrimary: TypographyColorToken = 'primary-light';
const colorTokenPromotion: TypographyColorToken = 'interaction-01-100';
const colorTokenSecondary: TypographyColorToken = 'interaction-03-90';

const defaultAppearance: AppearanceGroups = {
	costAppearance: {
		appearance: headlineToken,
		colorToken: colorTokenPrimary,
	},
	currencyAppearance: {
		appearance: body100Token,
		colorToken: colorTokenPrimary,
	},
	frequencyAppearance: {
		appearance: body75Token,
		colorToken: colorTokenPrimary,
	},
};

export const textAppearances: TextAppearances = {
	main: {
		...defaultAppearance,
	},
	promotionalMain: {
		costAppearance: {
			...defaultAppearance.costAppearance,
			colorToken: colorTokenPromotion,
		},
		currencyAppearance: {
			appearance: subtitle100Token,
			colorToken: colorTokenPromotion,
		},
		frequencyAppearance: {
			...defaultAppearance.frequencyAppearance,
			colorToken: colorTokenPromotion,
		},
	},
	secondary: {
		costAppearance: {
			appearance: headlineSecondaryToken,
			colorToken: colorTokenSecondary,
		},
		currencyAppearance: {
			appearance: subtitle100Token,
			colorToken: colorTokenSecondary,
		},
		frequencyAppearance: {
			...defaultAppearance.frequencyAppearance,
			colorToken: colorTokenSecondary,
		},
	},
	promotionalSecondary: {
		costAppearance: {
			appearance: headlineSecondaryToken,
			colorToken: colorTokenPromotion,
		},
		currencyAppearance: {
			appearance: subtitle100Token,
			colorToken: colorTokenPromotion,
		},
		frequencyAppearance: {
			...defaultAppearance.frequencyAppearance,
			colorToken: colorTokenPromotion,
		},
	},
	tertiary: {
		costAppearance: {
			...defaultAppearance.costAppearance,
			appearance: headlineSecondaryToken,
		},
		currencyAppearance: {
			...defaultAppearance.currencyAppearance,
			appearance: subtitle100Token,
		},
		frequencyAppearance: {
			...defaultAppearance.frequencyAppearance,
		},
	},
};
